var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 40,
    viewBox: "0 0 79 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8198 20C64.8198 31.0457 55.8656 40 44.8198 40C33.7741 40 24.8198 31.0457 24.8198 20C24.8198 8.95426 33.7741 0 44.8198 0C55.8656 0 64.8198 8.95426 64.8198 20ZM11.7966 20H22.9594V1.39535H11.7966V20ZM0.633789 38.6047H11.7966V20H0.633789V38.6047ZM76.1865 1.39535L74.3315 6.01085H74.2912L72.4361 1.39535H70.3408V8.83721H71.9346V4.37829H72.0671L73.7888 8.83721H74.8415L76.557 4.37829H76.6857V8.83721H78.2896V1.39535H76.1842H76.1865ZM63.4245 3.02791H65.5098V8.83721H67.3346V3.02791H69.4198V1.39535H63.4245V3.02791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/IO.e26fda34f6d2841d5ca47dd9d04722ff.svg";
export { ForwardRef as ReactComponent };